import { SelectedTabType } from '../../types';

export const EVENT_OPTIONS: { id: number; title: SelectedTabType | '(All)' }[] = [
  { id: 1, title: 'Alarms' },
  { id: 2, title: 'Logs' },
];
